import axiosInstance from './axios';

export const getBadgeFunnelStats = async ({ storeId, range = '7d' }) =>
  axiosInstance.get(`/api/v1/analytics/store/${storeId}/badge-funnel/`, {
    params: { range },
  });

export const getBadgeTimeseries = async ({ storeId, range = '30d' }) =>
  axiosInstance.get(`/api/v1/analytics/store/${storeId}/badge-timeseries/`, {
    params: { range },
  });

export const getBadgeHostLeaderboard = async ({ storeId, range = '7d', limit = 20 }) =>
  axiosInstance.get(`/api/v1/analytics/store/${storeId}/host-leaderboard/`, {
    params: { range, limit },
  });

export const getHostBadgeStats = async ({ hostId, range = '7d' }) =>
  axiosInstance.get(`/api/v1/analytics/host/${hostId}/badge-stats/`, {
    params: { range },
  });

export const postWaitingRoomEnter = async ({ demoId, sessionHash, source }) =>
  axiosInstance.post('/api/v1/analytics/waiting-room-enter/', {
    demo_id: demoId,
    session_hash: sessionHash,
    source,
  });
